import React, { useEffect, useState } from "react"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import persian_en from "react-date-object/locales/persian_en"

import DateObject from "react-date-object"
import { CloseCircleOutlined } from "@ant-design/icons"

// Single DatePicker in range mode. Calls setRange({ from, to }) where from/to are objects
// with { gregorian, persian, julianDay }
const PersianDatePickerRange = ({
  setRange,
  defaultFrom,
  defaultTo,
  disabled = false,
  placeholder,
}) => {
  const [value, setValue] = useState(null)

  const handleClear = () => {
    // clear local state and inform parent
    setValue(null)
    try {
      setRange({ from: null, to: null })
    } catch (e) {
      // ignore if setRange not provided
    }
  }

  useEffect(() => {
    if (defaultFrom && defaultTo) {
      try {
        const fromObj = new DateObject(defaultFrom)
        const toObj = new DateObject(defaultTo)
        setValue([fromObj, toObj])
        const conv = d => ({
          gregorian: new DateObject(d)
            .convert(gregorian, gregorian_en)
            .format("YYYY-MM-DD"),
          persian: new DateObject(d).convert(persian, persian_en).format(),
          julianDay: new DateObject(d),
        })
        console.log('from: conv(fromObj), to: conv(toObj)', { from: conv(fromObj), to: conv(toObj) });

        setRange({ from: conv(fromObj), to: conv(toObj) })
      } catch (e) {
        // ignore invalid defaults
      }
    }
  }, [])

  useEffect(() => {
    if (!value || !Array.isArray(value) || value.length < 2) {
      setRange({ from: null, to: null })
      return
    }
    const [fromD, toD] = value
    const conv = d => ({
      gregorian: new DateObject(d)
        .convert(gregorian, gregorian_en)
        .format("YYYY-MM-DD"),
      persian: new DateObject(d).convert(persian, persian_fa).format(),
      julianDay: new DateObject(d),
    })
    setRange({ from: conv(fromD), to: conv(toD) })
  }, [value])

  return (
    <div style={{ position: "relative" }}>
      <DatePicker
        value={value}
        onChange={setValue}
        range
        calendar={persian}
        locale={persian_fa}
        editable={false}
        disabled={disabled}
        placeholder={placeholder || "از - تا"}
        containerStyle={{
          paddingTop: "0.2rem",
        }}
        portal // 👈 enables rendering in a portal (to body)
        portalTarget={document.body}
      />
      {!disabled && value && Array.isArray(value) && value.length > 0 && (
        <button
          type="button"
          title="پاک کردن بازه"
          aria-label="Clear date range"
          onClick={handleClear}
          style={{
            position: "absolute",
            left: 6,
            top: 3,
            border: "1px solid rgba(0,0,0,0.08)",
            background: "#fff",
            cursor: "pointer",
            width: 28,
            height: 28,
            padding: 0,
            borderRadius: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        >
          <CloseCircleOutlined style={{ fontSize: 18, color: "#888" }} />
        </button>
      )}
    </div>
  )
}

export default PersianDatePickerRange
